import axios from "axios";
import qs from "qs";

const instance = axios.create({
  timeout: 100000,
  baseURL: "/your-year-in-review",
});

//  全局请求拦截，发送请求之前执行
instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
//  请求返回之后执行
instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // if (error.response?.status === 401) {
    //   window.location.href = "/login";
    // }
    return Promise.reject(error);
  },
);

const temp = new URLSearchParams(window.location.href.split("?")[1]);
const deviceTypeParams = temp.get("device_type")?.split("#")[0] || "";
const search = window.location.search.substring(1);

const HOST = window.location.host
const isDev = HOST?.includes('13457')

/**
 * @description:  TODO: 上线后删除默认 params！！！ >>>>
 * @param {*} url
 * @param {*} params
 * @param {*} sign
 * @return {*}
 */
export function get(url, params = {}, tag = false) {
  if (process.env.NODE_ENV === "production") {
    url = "https://" + window.location.host + "/your-year-in-review" + url;
  } else if (process.env.NODE_ENV === "development") {
    params = {
      ...params,
      uid: "110284379",
      sign: "4582c46f0c8a59b6f7f4e3b165e91d2c",
      // uid: '110285466', sign: 'cfad1e16249c59f5797fe91b6b777a5e'
    };
  }
  // if(tag){

  // let par = search.split('&')
  // let paramslist = {};
  //   par.forEach((ele)=>{
  //     let item  = ele.split('=')
  //     console.log(item)
  //     paramslist[item[0]] = item[1]
  //   })
  //   if(params.uid){
  //     paramslist.uid = params.uid
  //   }
  //   search = paramslist
  // }

  return instance.get(
    deviceTypeParams ? `${url}?${search}` : url,
    {
      params,
    },
    {
      headers: {
        cookies: "lang=cn;night=1",
      },
    },
  );
}

export function post(url, data) {
  if (process.env.NODE_ENV === "production") {
    url = "https://" + window.location.host + "/your-year-in-review" + url;
  }
  return instance.post(
    deviceTypeParams ? `${url}?${search}` : url,
    qs.stringify(data),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    },
  );
}

export async function getToken(params) {
  let momentToken = '';
  const url = '/apiweb/v1/moments/get_moments_token';
  try {
    // 透传 webview 的参数
    const res = await axios.get(url + '?' + params);

    if (res.data.code === 0) {
      momentToken = res.data.data;
    }
  } catch (error) { }
  return momentToken;
}

export function shareToPost({
  momentToken,
  content,
  images,
}) {
  var data = {
    moments_token: momentToken,
    platform: 'web',
    appLang: window.$$g_lang,
    type: 'images_text',
    content: content,
    images: JSON.stringify(images),
    source: 'year-report', // 区分是年度账单分享
  };
  const params = new URLSearchParams()
  for (const k in data) {
    params.append(k, data[k])
  }
  var config = {
    method: 'post',
    withCredentials: true,
    url: process.env.NODE_ENV === "development" ? '/message/create' : `https://${isDev ? `${HOST.split(':')[0]}:1443` : 'social-cdn.gposts.net'}/message/create`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: params
  };

  return axios(config);
}


export function uploadImgSher({
  momentToken,
}) {
  const data = {
    moments_token: momentToken,
    platform: 'web',
    appLang: window.$$g_lang,
  };
  const params = new URLSearchParams()
  for (const k in data) {
    params.append(k, data[k])
  }
  const config = {
    method: 'post',
    withCredentials: true,
    url: process.env.NODE_ENV === "development" ? '/message/upload' : `https://${isDev ? `${HOST.split(':')[0]}:1443` : 'social.gateio.im'}/message/upload`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  };

  return axios(config);
}